<template>
  <v-container fluid grid-list-md v-if="selectedPlan !== null && selectedPlan !== undefined">
    <material-card :title="$t('components.drawer.plan_files')" icon="description">
      <pbas-data-table
        ref="fileTable"
        :dataProvider="fileProvider"
        :showSelect="false"
        @error="error=$event"
      ></pbas-data-table>
    </material-card>

    <error-handler :error="error"></error-handler>
  </v-container>
  <div v-else>
    <v-row justify="center">
      <v-progress-circular
        :size="70"
        :width="7"
        color="accent"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { ODataProvider } from "pbas-vue-components";
import AdminFilesHeaders from "../headers/AdminFiles";
import ErrorHandler from "../components/ErrorHandler";
import { planSetter } from "../mixins/planSetter";
export default {
  components: {
    ErrorHandler,
  },
  mixins: [planSetter],
  data() {
    return {
      error: null,
      showFileEdit: false,
      fileProvider: undefined,
      selectedFile: { CategoryId: undefined },
      fileRowActions: [
        {
          name: "download",
          icon: "file_download",
          title: "globals.download",
          handler: (e) => {
            return this.downloadPdf(e);
          },
        },
      ],
    };
  },
  computed: {
    ...mapGetters("common", { selectedPlan: "plan", settings: "settings" }),
    ...mapGetters("common", ["language"]),
  },
  watch: {
    selectedPlan: {
      handler() {
        this.loadPlanData();
      },
    },
  },
  mounted() {
    if (this.selectedPlan !== null && this.selectedPlan !== undefined) {
      this.loadPlanData();
    }
  },
  methods: {
    ...mapActions("plansMembers", ["getCoverageByDate", "getPlan"]),
    ...mapActions("data", ["fetchFile"]),
    async loadPlanData() {
      this.uploadUrl = this.settings.APIURL + "cms/PhysicalFile/Upload";
      await this.refresh();
    },
    async refresh() {
      // try {
      this.fileProvider = new ODataProvider(
        this.$axiosHttp,
        this.settings.APIURL +
          "cms/odata/Plans(" +
          this.selectedPlan.Id +
          ")/DownloadCenterFiles",
        AdminFilesHeaders
      );
      await this.$refs.fileTable.getDataAsync();
      // } catch (error) {
      //   this.error = error;
      // }
    },
    async downloadPdf(item) {
      const trans = item.Translations.filter(
        (o) => o.LanguageCode === this.language.language
      );
      if (trans.length > 0) {
        try {
          const response = await this.fetchFile({
            url: trans[0].PhysicalFile.Path,
            filename: trans[0].DisplayName,
          });
          this.downloadBlob(new Blob([response.data]), this.file.PDFName);
        } catch (e) {
          console.log(e);
          this.e = e;
        }
      } else {
        this.error = {
          customMessage: this.$t("global.translation_not_found"),
        };
      }
    },
    downloadBlob(blob, filename) {
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename); //or any other extension
      link.setAttribute("id", "link1"); //or any other extension
      document.body.appendChild(link);
      link.click();
      var element = document.getElementById("link1");
      element.parentNode.removeChild(element);
    },
  },
};
</script>